import { useEffect, useState } from 'react';
import styled from 'styled-components';
import tw from 'twin.macro';

interface CopyCompleteModalProps {
  isShowModal: boolean;
  onClose: () => void;
}

export const CopyCompleteModal = ({ isShowModal, onClose }: CopyCompleteModalProps) => {
  const [isShow, setIsShow] = useState<boolean>(false);

  useEffect(() => {
    if (isShowModal === true) {
      setIsShow(true);

      setTimeout(() => {
        setIsShow(false);
        onClose();
      }, 500);
    }
  }, [isShowModal, onClose]);

  if (!isShow) {
    return <></>;
  }

  return <Container>{'복사가 완료되었습니다.'}</Container>;
};

const Container = styled.div`
  position: fixed;

  width: 300px;
  top: 150px;
  left: 50%;

  padding: 32px;

  color: black;
  background-color: #fff;

  border-radius: 16px;

  display: flex;
  justify-content: center;
  align-items: center;

  z-index: 9999;

  transform: translateX(-50%);

  ${tw`shadow-md`}
`;
